import { __read, __spreadArray } from "tslib";
var Listeners = /** @class */ (function () {
    function Listeners(target) {
        var _this = this;
        this.target = target;
        this.listeners = [];
        this.removeAll = function () {
            _this.listeners.forEach(function (listener) { var _a; return (_a = _this.target) === null || _a === void 0 ? void 0 : _a.removeEventListener.apply(_a, __spreadArray([], __read(listener), false)); });
        };
    }
    Listeners.prototype.add = function (eventName, handler, options) {
        var _a;
        (_a = this.target) === null || _a === void 0 ? void 0 : _a.addEventListener(eventName, handler, options);
        this.listeners.push([eventName, handler, options]);
    };
    return Listeners;
}());
export { Listeners };
//# sourceMappingURL=Listeners.js.map